interface IQueryResponseStatistics {
    lastWrite: number;
    totalResults: number;
}

class SiteElementProductNavigation
    extends QueryElement<HTMLElement> {
    private _prev: QueryElement<HTMLElement>;
    private _next: QueryElement<HTMLElement>;

    constructor(element: HTMLElement, site: SiteAssortment, url: string) {
        super(element);

        var id = url.substring(17);
        var products = site.query(".element-product").first<SiteElementProduct>();
        var product = products?.getById(id);

        if (product == null)
            this.remove();

        var prev = this.query(".element-product-navigation-prev").first<QueryElement<HTMLElement>>();
        var next = this.query(".element-product-navigation-next").first<QueryElement<HTMLElement>>();

        if (prev == null || next == null)
            throw "Cannot find all elements.";
        
        this._prev = prev;
        this._next = next;

        this._prev.on("click", () => {
            var prevProduct = product?.parent()?.prev()?.lastChild<SiteElementProductItem>();

            // Go to next page?
            if (prevProduct == null)
                prevProduct = product
                    ?.parent()?.parent()?.parent()
                    ?.prev()
                    ?.firstChild()?.query(".item").last()?.lastChild<SiteElementProductItem>();

            if (prevProduct != null)
            {
                prevProduct.get()?.scrollIntoView(false);
                site.openPopup(`${url.substring(0,17)}${prevProduct.getId()}`);
            }
        });
        this._next.on("click", () => {
            var nextProduct = product?.parent()?.next()?.lastChild<SiteElementProductItem>();

            // Go to next page?
            if (nextProduct == null)
                nextProduct = product
                    ?.parent()?.parent()?.parent()
                    ?.next()
                    ?.firstChild()?.firstChild()?.lastChild<SiteElementProductItem>();

            if (nextProduct != null)
            {
                nextProduct.get()?.scrollIntoView(false);
                site.openPopup(`${url.substring(0,17)}${nextProduct.getId()}`);
            }
        });
    }
}

class SiteElementProduct
    extends QueryElement<HTMLElement> {

    private readonly _config = {
        perPage: 25,
        extraRowsTop: 2,
        extraRowsBottom: 2,

        maxRefresh: 120,
        autoRefresh: false
    };

    private readonly _style: CSSStyleDeclaration;
    private readonly _site: Site;
    private _templateWidth: number = 0;
    private _templateHeight: number = 0;
    private _layout: string | null = null;

    private _filterModel: ISiteFilterModel;
    private _width: number = 0;
    private _height: number = 0;
    private _top: number = 0;

    private _statistics: IQueryResponseStatistics = {
        totalResults: 25,
        lastWrite: 0
    };

    private _pages: SiteElementProductPage[]
        = [];

    private _listGroupId: string | null;

    constructor(element: HTMLElement, site: SiteAssortment, filterModel: ISiteFilterModel) {
        super(element);

        this._site = site;
        this._filterModel = filterModel;
        this._listGroupId = this.getAttr("data-listGroupId") ?? null;
        
        let style = this.style();
        if (style === undefined)
            throw "Couldn't access style attribute!";

        this._style = style;
        let f = debounce(() => this.render(), 250);
        this._site.on("scroll", f);
        
        window.onresize = () => this.resize();

        if(Site.isMobile())
            this.setLayout(site.getDefaultMobileLayout().toLowerCase());
        else
            this.setLayout(site.getDefaultLayout().toLowerCase());
    }
    getListGroupId() {
        return this._listGroupId;
    }
    getById(id: string) {
        return this.query(`[data-id="${id}"]`).first<SiteElementProductItem>();
    }
    getLayout() {
        return this._layout;
    }
    setLayout(name: string) {
        if (this._layout != null)
            this.removeClass(this._layout);
        
        var newLayout = `layout-${name}`;
        this.addClass(newLayout);
        this._layout = newLayout;

        this.calculateTemplateDimensions();
        this.resize();
    }

    scrollTop() {
        return window.scrollY - this._top;
    }

    private _displaying: { from: number, to: number } = {
        from: 0,
        to: 0
    };
    async render() {
        let scrollTop = this.scrollTop();
        let columns = this.getColumns();

        let firstRow = (scrollTop / this._templateHeight) - this._config.extraRowsTop;
        if (firstRow < 0)
            firstRow = 0;
        
        let lastRow = ((scrollTop + this._height) / this._templateHeight) + this._config.extraRowsBottom;
        let lastCalculatedRow = Math.ceil(this._statistics.totalResults / columns);
        if (lastRow > lastCalculatedRow)
            lastRow = lastCalculatedRow;
        
        let from = Math.floor(firstRow * columns / this._config.perPage);
        let to = Math.ceil(lastRow * columns / this._config.perPage);
        
        //console.log(`${scrollTop}; Columns: ${columns}; Results: ${this._statistics.totalResults}; FirstRow: ${firstRow}; LastRow: ${lastRow}; LastCalculatedRow: ${lastCalculatedRow}; FromPage: ${from}; ToPage: ${to}`);

        // Hide displaying.from to from
        for (let x = this._displaying.from; x < from; x++) {
            let toHide = this._pages[x];
            if (toHide !== undefined)
                toHide.hide();
        }
        // Hide to to displaying.to
        for (let x = to; x <= this._displaying.to; x++) {
            let toHide = this._pages[x];
            if (toHide !== undefined)
                toHide.hide();
        }
        this._displaying = {
            from: from,
            to: to
        };

        // Show / get pages
        for (let x = Math.max(from, this._displaying.from); x < Math.min(to, this._displaying.to); x++) {
            let result = this._pages[x];
            if (this._pages[x] === undefined) {
                let request = this.request(x);
                if (request != null) {
                    this._pages[x] = request;
                    this.setStatistics(await this._pages[x].request());
                }    
            }
            else {
                result.show();

                //if (result.isExpired())
                //    this.setStatistics(await result.request());
            }
        }
    }
    resize() {
        let position = this.position();
        if (position === null)
            throw "Can't get position";
        
        this._top = position.top + document.documentElement.scrollTop;
        this._width = document.documentElement.clientWidth - position.left - (document.documentElement.clientWidth - position.right);
        this._height = document.documentElement.clientHeight;

        console.log(`Width: ${this._width}; Height: ${this._height}`);
        this.setStatistics(this._statistics);
        
        let elementAfter = this.children<SiteElementProductPage>()
        for(var item of elementAfter)
        {
            item.resize();
        }
        this.render();
    }
    setStatistics(statistics: IQueryResponseStatistics) {
        this._statistics = statistics;
        if (statistics.totalResults == -1) {
            var position = this._pages[0].position();
            if (position)
                this._style.height = `${position.height}px`;
        } else {
            this._style.height = `${Math.ceil(this._statistics.totalResults / this.getColumns()) * this._templateHeight}px`;
        }
    }
    request(page: number) {
        var productPage = new SiteElementProductPage(this, page);

        this.append(productPage);
        return productPage;
    }
    getTemplateWidth() : number {
        return this._templateWidth;
    }
    getTemplateHeight() : number {
        return this._templateHeight;
    }
    getColumns() : number {
        return Math.floor(this._width / this._templateWidth) || 1;
    }
    getPerPage() : number {
        return this._config.perPage;
    }
    getFilterModel(): ISiteFilterModel {
        return this._filterModel;
    }
    getSite() {
        return this._site;
    }
    async setFilterModel(filter: ISiteFilterModel) {
        this._filterModel = filter;

        let firstPage = new SiteElementProductPage(this, 0);
        this._statistics = await firstPage.request();

        for(let page of this._pages) {
            if (page != null)
                await page.remove();
        }

        this._pages = [firstPage];
        this.append(firstPage);
        this.resize();
    }
    private calculateTemplateDimensions() {
        var itemTemplate = QueryElement.QueryElement("DIV")
            .addClass("item")
            .appendTo(this);
        
        var itemTemplateElement = itemTemplate.get() as HTMLElement;
        if (itemTemplateElement === null)
            throw "Can't get element";
        
        this._templateHeight = itemTemplateElement.offsetHeight;
        this._templateWidth = itemTemplateElement.offsetWidth;

        console.log(`TemplateWidth: ${this._templateWidth}; TemplateHeight: ${this._templateHeight}`);
        
        itemTemplateElement.remove();
    }
}

class SiteElementProductPage
    extends QueryElement<HTMLElement> {

    private _page: number;
    private _style: CSSStyleDeclaration;
    private _limit: { start: number; end: number; }
    private _parent: SiteElementProduct;
    private _container: SiteElementProductContainer | null = null;

    constructor(parent: SiteElementProduct, page: number) {
        super(document.createElement("div"));
        this.addClass("page");

        let style = this.style();
        if (style === undefined)
            throw "Unable to get style!";

        this._page = page;
        this._style = style;
        this._parent = parent;

        let perPage = parent.getPerPage();

        this._limit = {
            start: (page * perPage),
            end: ((page + 1) * perPage)
        }

        console.log(`Page: ${page}`);

        this.resize();
    }
    resize() {
        let columns = this._parent.getColumns();
        var skipColumns = Math.floor(this._limit.start / columns);
        this._style.top = `${skipColumns * this._parent.getTemplateHeight()}px`;

        if (this._container != null) {
            this._container.resize();
        }
    }
    async request() {
        let request = new QueryRequest('/Assortment/Items', {
            contentType: 'json',
            method: 'post',
            data: JSON.stringify({
                from: this._limit.start,
                to: this._limit.end,
                filter: this._parent.getFilterModel()
            })
        });

        let response = await request.request();
        if (response.status == 200) {
            this.setHtml(await response.text());

            var container = this.query(".page-container").create<SiteElementProductContainer, HTMLElement>(a => new SiteElementProductContainer(a, this._parent, this._limit));
            if (container == null)
                throw "Container doesn't exist!";

            this._container = container;
            return this._container.getConfig();
        } else {
            this.setHtml(await response.text());
            let statistics : IQueryResponseStatistics = {
                lastWrite: 0,
                totalResults: -1
            };
            return statistics;
        }
    }
    show() {
        this._style.display = "";
    }
    hide() {
        this._style.display = "none";
    }
}

class SiteElementProductStaticContainer
    extends QueryElement<HTMLElement> {

    constructor(element: HTMLElement, site: Site) {
        super(element);

        this.query(".product").createAll<IQueryElement, HTMLElement>(a => new SiteElementProductItem(a, site, null));
    }
}

class SiteElementProductContainer
    extends QueryElement<HTMLElement> {

    private _startSpacer: SiteElementProductSpacer;
    private _endSpacer: SiteElementProductSpacer;
    private _parent: SiteElementProduct;
    private _limit: { start: number; end: number; };
    private _config: IQueryResponseStatistics;

    constructor(element: HTMLElement, parent: SiteElementProduct, limit: { start: number; end: number; })
    {
        super(element);

        this._parent = parent;
        this._limit = limit;
        this._startSpacer = new SiteElementProductSpacer(this._parent, "start").appendTo(this);
        this._endSpacer = new SiteElementProductSpacer(this._parent, "end").appendTo(this);

        this.query(".product").createAll<IQueryElement, HTMLElement>(a => new SiteElementProductItem(a, this.getSite(), this._parent.getListGroupId()));

        var config = this.getAttr("data-config");
        if (config == null)
            throw "Unable to read config!";
        
        this._config = JSON.parse(config) as IQueryResponseStatistics;

        this.resize();
    }

    resize() {
        let columns = this._parent.getColumns();
        let startSpacer = this._limit.start % columns;
        let endSpacer = columns - (this._limit.end % columns);
        if (endSpacer == columns)
            endSpacer = 0;
        
        this._startSpacer.resize(startSpacer);
        this._endSpacer.resize(endSpacer);

        console.log(`Columns: ${columns}; StartSpacer: ${startSpacer}; EndSpacer: ${endSpacer}`);
    }

    getConfig()
    {
        return this._config;
    }

    getSite()
    {
        return this._parent.getSite();
    }
}


class SiteElementProductItemFavorite
    extends QueryElement<HTMLElement> {

    private readonly _site: Site;
    private readonly _id: string;

    constructor(element: HTMLElement, site: Site, id: string) {
        super(element);

        this._site = site;
        this._id = id;

        if (this.getAttr("data-is-favorite") == "True")
            this.addClass("active");

        this.on("click", a => {
            this.click();
        });
    }

    isActive() {
        return this.containsClass("active");
    }

    async click() {

        let request = new QueryRequest(
            `/Favorites/${this.isActive() ? "Delete" : "Put"}/${this._id}`, {
            contentType: 'json',
            method: 'get'
        });

        await request.request();

        if (this.isActive()) {
            this.removeClass("active");
        } else {
            this.addClass("active");
        }

        var favorites = this._site.getFavorites();
        if (favorites != null)
            await favorites.reload();
    }

}

class SiteElementProductItemHistory
    extends QueryElement<HTMLElement> {
    
    constructor(quantity: string) {
        super(document.createElement("div"));

        this.addClass("item")
            .setText(quantity);
    }
}

type SiteElementProductItemStatuses = 'Ok' | 'Busy' | 'Error' | 'Unknown';
class SiteElementProductItem
    extends QueryElement<HTMLElement>
    implements ISiteElementQuantityPickerSubmit {

    private readonly _status: IQueryElement | null;
    private readonly _id: string;
    private readonly _listGroupId: string | null;
    private readonly _site: Site;
    private _currentStatus?: SiteElementProductItemStatuses;
    private _history: IQueryElement | null;

    constructor(element: HTMLElement, site: Site, listGroupId: string | null) {
        super(element);

        this._site = site;
        let id = this.getId();
        if (id == null)
            throw "ID not found!";
        
        this._id = id;
        this._listGroupId = listGroupId;

        let status = this.query(".status").first();
        let history = this.query(".history").first();
        let favorite = this.query(".favorite").create<IQueryElement, HTMLElement>(a => new SiteElementProductItemFavorite(a, this._site, this._id));
        let quantityPicker = this.query(".quantity-picker")
            .createAll<ISiteElementQuantityPicker, HTMLElement>(a => new SiteElementQuantityPicker(a, this))
            .concat(this.query(".quantity-picker-number")
                .createAll<ISiteElementQuantityPicker, HTMLElement>(a => new SiteElementQuantityPickerNumber(a, this)));

        this._status = status;
        this._history = history;

        var x = 0;
        this.query(".element-price").create<IQueryElement, HTMLElement>(a => {
            var quantityPickerItem = quantityPicker[x];
            x++;

            if (quantityPickerItem == null)
                return null;
            return new SiteElementPrice(a, quantityPickerItem);
        });

        // Parse popup
        this.query(".event-popup").all(a => {
            var href = a.getAttr("href");
            if (href && href.charAt(0) != '#')
                a.setAttr("href", `#${href}`);
        });
        
        this.query(".event-redirect").all(a => {
            a.on("click", e => {
                var href = a.getAttr("href");
                if (href) {
                    window.location.href = href.replace("%7B0%7D", encodeURIComponent(window.location.pathname))
                }
                e.stop();
            });
        });
        
        this.query(".collapsible").createAll<IQueryElement, HTMLElement>(a => new SiteElementCollapsible(a));
        this.setHistory();
    }

    getId() {
        return this.getAttr("data-id");
    }

    setHistory() {
        if (this._history == null)
            return;

        var items = this._site.getShoppingCart()?.getItem(this._id);
        if (items != null)
        {
            for(var item of items)
            {
                this._history.append(new SiteElementProductItemHistory(`${item.quantity} x ${item.quantityPerUnit}`));
            }
        }
        
    }

    async submit(debtorId: string, quantity: number) : Promise<SiteBuyResponse>
    {
        // Prevent double firing
        if (this._currentStatus == "Busy")
            return "Error";
        
        this.setStatus("Busy");

        let request = new QueryRequest(
            `/Cart/Create/${this._id}`, {
            contentType: 'json',
            method: 'post',
            data: JSON.stringify({
                quantity: quantity,
                listGroupId: this._listGroupId,
                debtorId: debtorId
            })
        });

        var response = await request.request();
        var jsonResponse: IResponse = await response.json();
        switch(jsonResponse.type)
        {
            case "Cart":
            {
                let payLoad = <ICartPayloadResponse>jsonResponse.payLoad;
                if (payLoad.succeeded)
                {          
                    this.setStatus("Ok");
                    this._site.eventAddedPreOrder();
                    return "Ok";
                }
                else
                {
                    this.setStatus("Error");
                    return "Error";
                }
            }
            case "Message":
            {
                let payLoad = <IMessagePayloadResponse>jsonResponse.payLoad;
                this._site.addMessage(payLoad);

                if (payLoad.sort == "Info")
                {
                    this.setStatus("Unknown");
                    this._site.eventAddedPreOrder();
                    return "Unknown";
                }
                else
                {
                    this.setStatus("Error");
                    return "Error";
                }
            }
            default:
            {
                this.setStatus("Error");
                return "Error";
            }
        }
    }

    setStatus(status: SiteElementProductItemStatuses)
    {
        this._currentStatus = status;
        
        if (this._status == null)
            return;
        
        this._status.setAttr("class", "status");
        switch(status)
        {
            case 'Ok':
                this._status.addClass("status-ok").setHtml(`<i>done</i>`);
                break;
            case 'Busy':
                this._status.addClass("status-busy").setHtml(`<i>schedule</i>`);
                break;
            case 'Error':
                this._status.addClass("status-error").setHtml(`<i>clear</i>`);
                break;
            case 'Unknown':
                this._status.addClass("status-unknown").setHtml(`<i>question_mark</i>`);
                break;
        }
    }
}
class SiteElementProductSpacer
    extends QueryElement<HTMLElement> {
    
    private _style: CSSStyleDeclaration;
    private _parent: SiteElementProduct;

    constructor(parent: SiteElementProduct, className: string) {
        super(document.createElement("div"));
        this.addClass("spacer");
        this.addClass(className);

        let style = this.style();
        if (style === undefined)
            throw "Unable to get style!";

        this._style = style;
        this._parent = parent;
    }

    resize(number: number)
    {
        this._style.width = `${number * this._parent.getTemplateWidth()}px`;
        this._style.flexGrow = number + "";
    }
}